import type { AmplitudeIdentity } from './amplitudeInitOptions'

/** The event shape the plugin touches (Browser SDK 2.x `Event`, trimmed). */
interface AmplitudeEnrichedEvent {
  event_type: string
  event_properties?: Record<string, unknown>
}

/** A Browser SDK 2.x enrichment plugin, as `amplitude.add` takes it. */
export interface AmplitudeEnrichmentPlugin {
  name: string
  type: 'enrichment'
  execute: (event: AmplitudeEnrichedEvent) => Promise<AmplitudeEnrichedEvent>
}

/** SDK-internal identify events: user-property operations, no event properties. */
const IDENTIFY_EVENT_TYPES = new Set(['$identify', '$groupidentify'])

/**
 * Stamps `consent_mode` (`consented` / `cookieless`) on every event the page
 * sends, SDK-generated ones included (`[Amplitude] Page Viewed`, session
 * start / end) — so any web chart can be split by how the visitor is
 * counted (TASK-1172). The two modes count differently: `cookieless` is one
 * user per visitor per day with no country, `consented` spans visits, so a
 * number that mixes them silently is not comparable across days with a
 * different consent share.
 */
export function consentModePlugin(mode: AmplitudeIdentity['mode']): AmplitudeEnrichmentPlugin {
  return {
    name: 'metro-consent-mode',
    type: 'enrichment',
    execute: async (event) => {
      if (IDENTIFY_EVENT_TYPES.has(event.event_type)) return event
      event.event_properties = { ...event.event_properties, consent_mode: mode }
      return event
    },
  }
}
